import React from 'react'

const AutomationOptionsLocation = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="53" viewBox="0 0 33 53" fill="none" className={className}>
    <path
      d="M31.34 16.42C31.34 24.65 16.42 51.42 16.42 51.42C16.42 51.42 1.5 24.62 1.5 16.42C1.5 12.463 3.07189 8.66801 5.86993 5.86997C8.66798 3.07192 12.463 1.5 16.42 1.5C20.377 1.5 24.172 3.07192 26.97 5.86997C29.7681 8.66801 31.34 12.463 31.34 16.42V16.42Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M16.4196 24.81C20.7385 24.81 24.2396 21.3089 24.2396 16.99C24.2396 12.6712 20.7385 9.17004 16.4196 9.17004C12.1007 9.17004 8.59961 12.6712 8.59961 16.99C8.59961 21.3089 12.1007 24.81 16.4196 24.81Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsLocation
